import React, { useEffect, useState } from "react";
import styled from "styled-components";
import FlightAbstractImg from "../../../assets/images/image_flighttravel.png";
import FromIcon from "../../../assets/images/from.png";
import ToIcon from "../../../assets/images/to.png";
import Box from "../../../components/Box";
import FlightDataHeaderWrapper from "./FlightDataHeaderWrapper";
import FlightDataBodyWrapper from "./FlightDataBodyWrapper";
import SelectFlightHeader from "./SelectFlightHeader";
import { Colors, Text } from "../../../config";
import DetailsContainer from "./DetailsContainer";
import SelectedFlightDetailBox from "./SelectedFlightDetailBox";
import PageBackButton from "../../../components/PageBackButton";
import { useNavigate } from "react-router-dom";

const qatarNameImg = require("../../../assets/images/Qatar-Airways-Logo.png");

const SelectFlight = () => {
  const navigate = useNavigate();

  const [activeCell, setActiveCell] = useState(1);
  const [openDetails, setOpenDetails] = useState(-1);
  const [isSelectedFlightAvailable, setIsSelectedFlightAvailable] =
    useState(false);
  const [isGuest, setIsGuest] = useState(false);

  const setOpenCloseDetails = (detailNo) => {
    detailNo === openDetails ? setOpenDetails(-1) : setOpenDetails(detailNo);
  };

  useEffect(() => {
    setIsSelectedFlightAvailable(false); //true if selected flight data is present
    setIsGuest(false); //true if guest data
    setOpenDetails(-1);
  }, []); // eslint-disable-line

  return (
    <>
      {isSelectedFlightAvailable && <SelectedFlightDetailBox />}
      <SelectFlightContainer>
        <JourneyDataWrapper>
          <Heading>
            <PageBackButton
              label={isGuest ? Text.SelectGuestFlight : Text.selectFlight}
              handleClick={() => navigate("/user/dashboard")}
            />
          </Heading>
          <JourneyDataContainer>
            <FlightAbstract src={FlightAbstractImg} />
            <JourneyDetails>
              <JourneyDetailsSection>
                <SectionHeader>Round Trip</SectionHeader>
                <JourneyDetailsCell>
                  <CellHeader>Passengers</CellHeader>
                  <PassengetCell>
                    <HighlightJourneyText>2</HighlightJourneyText>
                    <CountLabel>Adult</CountLabel>
                  </PassengetCell>
                </JourneyDetailsCell>
                <JourneyDetailsCell>
                  <CellHeader>From</CellHeader>
                  <DirectionCell>
                    <HighlightJourneyText>DOH</HighlightJourneyText>
                    <DirectionIcon src={FromIcon} />
                  </DirectionCell>
                </JourneyDetailsCell>
                <JourneyDetailsCell>
                  <CellHeader>Departure Date</CellHeader>
                  <DateText>
                    <HighlightJourneyText>FEB 24</HighlightJourneyText>
                    <DayText>Friday</DayText>
                  </DateText>
                </JourneyDetailsCell>
              </JourneyDetailsSection>
              <JourneyDetailsSection>
                <SectionHeader>Economy Class</SectionHeader>
                <JourneyDetailsCell>
                  <CellHeader>Adult</CellHeader>
                  <PaxList>
                    <PaxName>Wasim</PaxName>
                    <PaxName>Amina Wasim</PaxName>
                  </PaxList>
                </JourneyDetailsCell>
                <JourneyDetailsCell>
                  <CellHeader>To</CellHeader>
                  <DirectionCell>
                    <HighlightJourneyText>DXB</HighlightJourneyText>
                    <DirectionIcon src={ToIcon} />
                  </DirectionCell>
                </JourneyDetailsCell>
                <JourneyDetailsCell>
                  <CellHeader>Return Date</CellHeader>
                  <DateText>
                    <HighlightJourneyText>MAR 16</HighlightJourneyText>
                    <DayText>Wednesday</DayText>
                  </DateText>
                </JourneyDetailsCell>
              </JourneyDetailsSection>
            </JourneyDetails>
          </JourneyDataContainer>
        </JourneyDataWrapper>
        <FlightListWrapper>
          <SelectFlightHeader
            results={12}
            activeCell={activeCell}
            setActiveCell={setActiveCell}
          />
          <FlightList>
            <>
              <Box>
                <FlightDetails>
                  <FlightDataHeaderWrapper category={"Cheapest"} rating="4.5" />
                  <FlightDataBodyWrapper
                    detailNo={0}
                    openDetails={openDetails}
                    setOpenDetails={(detailNo) => setOpenCloseDetails(detailNo)}
                    flightName="Fly Dubai"
                    isConfirmBookingPage={false}
                    onSelectFlight={() => navigate('/user/dashboard/confirm-flights')}
                  />
                </FlightDetails>
              </Box>
              {openDetails === 0 && <DetailsContainer flightName="Fly Dubai" />}
            </>
            <>
              <Box>
                <FlightDetails>
                  <FlightDataHeaderWrapper category={"Cheapest"} rating="4.5" />
                  <FlightDataBodyWrapper
                    detailNo={1}
                    openDetails={openDetails}
                    setOpenDetails={(detailNo) => setOpenCloseDetails(detailNo)}
                    flightName="Qatar Airways"
                    imgSrc={qatarNameImg}
                    isConfirmBookingPage={false}
                    onSelectFlight={() => navigate('/user/dashboard/confirm-flights')}
                  />
                </FlightDetails>
              </Box>
              {openDetails === 1 && (
                <DetailsContainer
                  flightName="Qatar Airways"
                  imgSrc={qatarNameImg}
                />
              )}
            </>
          </FlightList>
        </FlightListWrapper>
      </SelectFlightContainer>
    </>
  );
};

const FlightList = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;
`;
const FlightDetails = styled.div``;

const SelectFlightContainer = styled.div`
  display: flex;
  gap: 2.5rem;
  width: calc(100% - 6rem);
  padding: 1rem 2.625rem;
  margin-top: 1rem;
`;

const JourneyDataWrapper = styled.div`
  width: 35%;
`;

const JourneyDataContainer = styled.div`
  background: ${Colors.brandOne};
  width: 100%;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
`;

const FlightAbstract = styled.img`
  width: 100%;
`;

const DirectionIcon = styled.img``;

const JourneyDetails = styled.div`
  padding: 0 2.5rem 3rem 2.5rem;
  display: flex;
`;

const JourneyDetailsSection = styled.div`
  text-align: left;
  flex: 1;
`;

const SectionHeader = styled.div`
  color: ${Colors.brandFive};
  font-size: 1.5rem;
  font-weight: 400;
`;

const JourneyDetailsCell = styled.div`
  margin-top: 2rem;
`;
const CellHeader = styled.div`
  color: ${Colors.brandTwo};
  font-size: 1.125rem;
  font-weight: 400;
`;

const PassengetCell = styled.div`
  display: flex;
  gap: 0.5rem;
  color: ${Colors.white};
  margin-top: 0.5rem;
`;

const CountLabel = styled.div`
  font-size: 1.25rem;
  line-height: 2.25rem;
`;

const DirectionCell = styled.div`
  display: flex;
  gap: 0.5rem;
  color: ${Colors.white};
  margin-top: 0.5rem;
  align-items: center;
`;

const HighlightJourneyText = styled.div`
  font-size: 2.5rem;
  font-weight: 600;
`;

const DayText = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${Colors.white};
  opacity: 0.4;
`;

const DateText = styled.div`
  display: flex;
  color: ${Colors.white};
  margin-top: 0.5rem;
  flex-direction: column;
`;

const PaxList = styled.div`
  display: flex;
  color: ${Colors.white};
  margin-top: 0.5rem;
  gap: 0.25rem;
  flex-direction: column;
`;
const PaxName = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
`;

const FlightListWrapper = styled.div`
  width: 65%;
`;

const Heading = styled.div`
  padding-bottom: 1.3rem;
`;

export default SelectFlight;
